var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUssd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9797",
    d: "M10 14a4 4 0 0 1 8 0 4 4 0 0 1-8 0zm10 0a4 4 0 0 1 8 0 4 4 0 0 1-8 0zm14-4a4 4 0 0 1 0 8 4 4 0 0 1 0-8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2DEDF",
    d: "M38 34a4 4 0 0 1-8 0 4 4 0 0 1 8 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9797",
    d: "M38 24a4 4 0 0 1-8 0 4 4 0 0 1 8 0zM28 34a4 4 0 0 1-8 0 4 4 0 0 1 8 0zm0-10a4 4 0 0 1-8 0 4 4 0 0 1 8 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2DEDF",
    d: "M14 38a4 4 0 0 1 0-8 4 4 0 0 1 0 8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9797",
    d: "M14 28a4 4 0 0 1 0-8 4 4 0 0 1 0 8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUssd);
export default __webpack_public_path__ + "static/media/ussd.8b8a935cce51d135c5024771690a2527.svg";
export { ForwardRef as ReactComponent };